import { TakeActionDropdownData } from 'components/TakeActionDropdown/types/TakeActionDropdownData';
import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';

export const takeActionDropdownDataEs: TakeActionDropdownData = {
  search: {
    title: 'Encuentra',
    items: [
      {
        type: 'volop',
        title: 'Voluntariado',
        href: getMainVolopsSearchRoutePath({ lang: 'es' }),
      },
      {
        type: 'event',
        title: 'Asiste a un Evento',
        href: getMainVolopsSearchRoutePath({
          lang: 'es',
          filters: {
            type: 'VOLOP',
            actionType: ['EVENT'],
          },
        }),
      },
    ],
  },
  resources: {
    title: 'Recursos',
    items: [
      {
        type: 'knowledge-base',
        title: 'Centro de Recursos para Recaudación de Fondos',
        description:
          'Consejos prácticos que te facilitarán la busca de recursos para tu organización o proyecto.',
        href: '/es/recursos-recaudacion-fondos',
      },
    ],
  },
};
